<form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
    <div class="input-group">
        <input class="form-control" placeholder="Выберите дату" formControlName="date" [dayTemplate]="customDay" [minDate]="valueDateTo" [maxDate]="valueDateFrom" readonly="true" id="valid_from" ngbDatepicker #vFrom="ngbDatepicker" (click)="vFrom.toggle()" >
        <div class="input-group-append">
            <button class="btn calendar" (click)="vFrom.toggle()" type="button">
                <svg-icon [svgStyle]="{'margin-bottom.px':3}" src="/assets/images/icons/calendar.svg" [stretch]="true"></svg-icon>
            </button>
        </div>
        <ng-template
            #customDay 
            let-date
            let-currentMonth="currentMonth"
            let-selected="selected"
            let-disabled="disabled"
            let-focused="focused">
            <span
                class="custom-day"
                [class.focused]="focused"
                [class.bg-primary]="selected"
                [class.hidden]="date.month !== currentMonth"
                [class.text-muted]="disabled">
                {{ date.day }}
            </span>
        </ng-template>
    </div>
</form>